import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider, App as AntApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { AuthGuard } from './components/AuthGuard'
import { MainLayout } from './layouts/MainLayout'
import Dashboard from './pages/Dashboard'
import DeviceList from './pages/DeviceList'
import DeviceDetail from './pages/DeviceDetail'
import VoiceSimulator from './pages/VoiceSimulator'
import DeviceSimulator from './pages/DeviceSimulator'
import DeviceProvision from './pages/DeviceProvision'
import DeviceProfileManage from './pages/DeviceProfileManage'
import Login from './pages/Login'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 10_000,
    },
  },
})

export default function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#1677ff' } }}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<AuthGuard><MainLayout /></AuthGuard>}>
                <Route index element={<Dashboard />} />
                <Route path="devices" element={<DeviceList />} />
                <Route path="devices/:id" element={<DeviceDetail />} />
                <Route path="simulator" element={<Navigate to="/simulator/voice" replace />} />
                <Route path="simulator/voice" element={<VoiceSimulator />} />
                <Route path="simulator/devices" element={<DeviceSimulator />} />
                <Route path="devices/provision" element={<DeviceProvision />} />
                <Route path="devices/profiles" element={<DeviceProfileManage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  )
}
